import React from "react";

import { css } from "@emotion/core";

import {
  Button,
  ButtonGroup,
  TooltipWrapper,
  useTheme,
} from "@zapier/design-system";
import { responsiveStylesFn } from "@zapier/responsive-utils";

import { useSize } from "@zapier/checkout/esm/hooks";

const wrapperStyles = responsiveStylesFn({
  small: css`
    display: flex;
    flex-direction: column;
  `,
  medium: css`
    flex-direction: row-reverse;
  `,
});

type ChangePlanButtonsProps = {
  isDisabled: boolean;
  onCancelChangePlan: () => void;
  onChangePlan: () => void;
  popoverText: string | null | undefined;
  submitText: string;
  downgradeHref?: string;
};

export const ChangePlanButtons = ({
  isDisabled,
  onCancelChangePlan,
  onChangePlan,
  popoverText,
  submitText,
  downgradeHref,
}: ChangePlanButtonsProps) => {
  const { isRebrand } = useTheme();
  const size = useSize();

  if (isRebrand) {
    return (
      <ButtonGroup
        columnSize={size === "small" ? "100%" : "minmax(100px, auto)"}
        justify="end"
      >
        <Button color="secondary" onClick={onCancelChangePlan} size="small">
          Cancel
        </Button>
        <TooltipWrapper content={popoverText}>
          {({ childProps }) => (
            <Button
              {...childProps}
              color="primary"
              disabled={isDisabled}
              {...(downgradeHref ? { href: downgradeHref } : {})}
              isFullWidth={true}
              onClick={onChangePlan}
              size="small"
            >
              {submitText}
            </Button>
          )}
        </TooltipWrapper>
      </ButtonGroup>
    );
  }

  return (
    <div css={wrapperStyles(size)}>
      <TooltipWrapper content={popoverText}>
        {({ childProps }) => (
          <Button
            {...childProps}
            color="primary"
            disabled={isDisabled}
            {...(downgradeHref ? { href: downgradeHref } : {})}
            isFullWidth={true}
            onClick={onChangePlan}
          >
            {submitText}
          </Button>
        )}
      </TooltipWrapper>
      <Button color="tertiary" onClick={onCancelChangePlan}>
        Cancel
      </Button>
    </div>
  );
};
